import api from "./api";

export const REASON_LABELS = {
  waiting_supplier: "⏳ Esperando proveedor",
  waiting_client:   "👤 Esperando cliente",
  call_later:       "📞 Llamar más tarde",
  stock_pending:    "📦 Falta stock / confirmación",
  internal_pending: "🏠 Pendiente interno",
  other:            "📝 Otro",
};

export const SNOOZE_PRESETS = [
  { key: "no_due_date",  label: "Solo marcar",      minutes: null },
  { key: "30m",          label: "30 minutos",        minutes: 30 },
  { key: "1h",           label: "1 hora",            minutes: 60 },
  { key: "3h",           label: "3 horas",           minutes: 180 },
  { key: "end_of_day",   label: "Fin del día",       minutes: null, special: "end_of_day" },
  { key: "tomorrow_9",   label: "Mañana 9:00",       minutes: null, special: "tomorrow_9" },
  { key: "next_week",    label: "Próxima semana",    minutes: null, special: "next_week" },
  { key: "custom",       label: "Personalizado...",  minutes: null, special: "custom" },
];

// Calcula la dueDate según el preset seleccionado
export const calcDueDate = (preset) => {
  if (!preset || preset.key === "no_due_date") return null;
  const now = new Date();
  if (preset.minutes) {
    return new Date(now.getTime() + preset.minutes * 60000).toISOString();
  }
  if (preset.special === "end_of_day") {
    const d = new Date(now);
    d.setHours(18, 0, 0, 0);
    if (d <= now) d.setDate(d.getDate() + 1);
    return d.toISOString();
  }
  if (preset.special === "tomorrow_9") {
    const d = new Date(now);
    d.setDate(d.getDate() + 1);
    d.setHours(9, 0, 0, 0);
    return d.toISOString();
  }
  if (preset.special === "next_week") {
    const d = new Date(now);
    const day = d.getDay();
    const daysToMonday = (8 - day) % 7 || 7;
    d.setDate(d.getDate() + daysToMonday);
    d.setHours(9, 0, 0, 0);
    return d.toISOString();
  }
  return null;
};

// API calls
export const getPending = (ticketId) =>
  api.get(`/ticket-pendings/ticket/${ticketId}`).then(r => r.data).catch(e => {
    if (e.response?.status === 404) return null;
    throw e;
  });

export const createPending = (ticketId, data) =>
  api.post("/ticket-pendings", { ticketId, ...data }).then(r => r.data);

export const updatePending = (id, data) =>
  api.put(`/ticket-pendings/${id}`, data).then(r => r.data);

export const resolvePending = (id, resolutionType = "manual_resolved") =>
  api.delete(`/ticket-pendings/${id}`, { data: { resolutionType } }).then(r => r.data);
